export class RouterHelpers {
  static getAllRoutesMeta(route, property) {
    if (!property || !route || !route.matched || route.matched.length === 0) {
      return [];
    }

    const routeAncestors = route.matched;
    const allRoutesMeta = routeAncestors
      // we only want the meta of this property
      .map((record) => record?.meta?.[property])
      // routeTree is going bottom to top, we want top to bottom to ensure the closest ancestor property
      // allowing a child to override a parent meta
      .reverse()
      // we remove the undefined values
      .filter((record) => record !== undefined);

    return allRoutesMeta;
  }

  /**
   * Get the meta property of the current route OR if not specified the closest property in its ancestors tree
   * @param {VueRouterRoute} route
   * @param {String} property - the meta property we are looking for
   * @returns {Any} - the meta property value (returns undefined if nothing is found)
   */
  static getRouteMeta(route, property) {
    return (
      RouterHelpers.getAllRoutesMeta(route, property)
        // we take the first result (the closest to the current route if not itself)
        .shift()
    );
  }

  /**
   * Return true if any of the route ancestors has set the provided property to true
   * @static
   * @param {VueRouterRoute} route
   * @param {String} property - the meta property we are looking for
   * @returns {Boolean} - true if the property exists and is true, false otherwise
   */
  static routeAncestorsMatchMeta(route, property) {
    if (!property || !route || !route.matched || route.matched.length === 0) {
      return false;
    }

    const routeAncestors = route.matched;
    return routeAncestors.some((record) => record?.meta?.[property] === true);
  }

  /**
   * Return true if the provided route name exists in the provided current route ancestor
   * @param {String} name
   * @param {VueRouterRoute} route
   * @returns
   */
  static routeHasAncestor(route, routeSegment) {
    const routeAncestors = route.matched;
    return routeAncestors.some((ancestor) => ancestor.name && ancestor.name.includes(routeSegment));
  }
}
